export default "__VITE_ASSET__C5FwBggk__"